import React from 'react';

import { T } from '../../../../../../common/locale/translate';
import Row from '../../../../common/components/responsive-table-row';
import Cell from '../../../../common/components/responsive-table-cell';
import Loader from '../../../../common/components/loader';

import {
  checkAvailability,
  link2OfferWithHotel
} from '../../../../services/services';

export default class HotelUpgrade extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current_state: 'pristine',
      loader: false,
      button_text: T('check_offer'),
      offer_link: 'javascript:void(0)',
      prices: {
        pln: 0,
        eur: 0,
        payment: 'per-person'
      },
      data: {}
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.setState({
      data: this.props.data,
      prices: {
        pln: Math.ceil(this.props.data.price_diff_pln),
        eur: Math.ceil(this.props.data.price_diff_eur),
        payment: 'per-person'
      }
    });
  }

  render = () => (
    <Row
      headers={this.props.headers}
      className={`${this.props.className ? this.props.className : ''} ${
        this.state.current_state
      }`}
    >
      {this.props.headers.map((header, i) =>
        this.ComponentElements(header.name, i)
      )}
    </Row>
  );

  handleClick = () => {
    if (this.state.current_state == 'pristine') {
      this.checkUpgradeAvailability();
    }
  };

  ComponentElements(key, index) {
    const data = this.props.data;
    const elements = {
      accommodation: (data, index) => (
        <Cell className="accommodation" key={`accommodation-${index}`}>
          <div className="accommodation-wrapper">
            {data.accommodation ? data.accommodation.polish_name : ' - '}
          </div>
        </Cell>
      ),
      alimentation: (data, index) => (
        <Cell className="alimentation" key={`alimentation-${index}`}>
          <div className="alimentation-wrapper">
            {data.boards.length ? data.boards[0].name : ' - '}
          </div>
        </Cell>
      ),
      suplement: (data, index) => (
        <Cell className="suplement" key={`suplement-${index}`}>
          <div className="suplement-wrapper">
            <div className="price-wrapper">
              {`${
                data.price_diff_pln > 0 && this.state.prices.payment !== 'total'
                  ? ' + '
                  : ''
              }${this.state.prices.pln}zł (${this.state.prices.eur} €) ${
                this.state.prices.payment == 'per-person'
                  ? T('per_person')
                  : T('total')
              }`}
            </div>
            <div className="action-wrapper">
              <a
                href={this.state.offer_link}
                className={`check-availability-button ${
                  this.state.current_state
                }`}
                onClick={this.handleClick}
              >
                {this.state.button_text}{' '}
                <span className="loading">
                  {this.state.loading_text}{' '}
                  <Loader active={this.state.loader} />
                </span>
              </a>
            </div>
          </div>
        </Cell>
      ),
      suplement_mobile: (data, index) => (
        <Cell className="suplement-mobile" key={`suplement-${index}`}>
          <div className="suplement-mobile-wrapper">
            <div className="price-wrapper">
              {`${
                data.price_diff_pln > 0 && this.state.prices.payment !== 'total'
                  ? ' + '
                  : ''
              }${this.state.prices.pln}zł (${this.state.prices.eur} €) ${
                this.state.prices.payment == 'per-person'
                  ? T('per_person')
                  : T('total')
              }`}
            </div>
          </div>
        </Cell>
      ),
      action_button_mobile: (data, index) => (
        <Cell className="mobile-action-button" key={`suplement-${index}`}>
          <div className="action-wrapper">
            <a
              href={this.state.offer_link}
              className={`check-availability-button ${
                this.state.current_state
              }`}
              onClick={this.handleClick}
            >
              {this.state.button_text}{' '}
              <span className="loading">
                {this.state.loading_text} <Loader active={this.state.loader} />
              </span>
            </a>
          </div>
        </Cell>
      )
    };

    return elements[key] ? elements[key](data, index) : <span> - </span>;
  }

  availabilityParams = () => ({
    parser: this.state.data.subject.parser,
    operator_code: this.state.data.operator.code,
    hotel_id: this.state.data.subject.id,
    adults_number: this.props.params.adults_number,
    children_ages: this.props.params.children_ages,
    offer_type: this.state.data.offer_type,
    offer_id: this.state.data.id,
    departure_date: this.state.data.departure_date,
    return_date: this.state.data.return_date
  });

  offerLinkParams = () => ({
    id: this.state.data.subject.id,
    operator_code: this.state.data.operator.code,
    parser: this.state.data.subject.parser,
    offer_type: this.state.data.offer_type,
    offer_id: this.state.data.id,
    adults_number: this.props.params.adults_number,
    children_ages: this.props.params.children_ages,
    departure_date: this.state.data.departure_date,
    return_date: this.state.data.return_date,
    accommodations: this.state.data.accommodations
      ? this.state.data.accommodations
      : ''
  });

  checkUpgradeAvailability() {
    const params = this.availabilityParams();
    this.setState(
      {
        current_state: 'in_progress',
        loader: true,
        button_text: T('checking')
      },
      () => {
        checkAvailability(params)
          .then(response => {
            const availabilityCode = response.data.availability.code;
            if (availabilityCode !== 'NA' && availabilityCode !== 'XX') {
              const link = link2OfferWithHotel(this.offerLinkParams());
              this.setState({
                current_state: 'available',
                loader: false,
                offer_link: link,
                button_text: T('choose'),
                prices: {
                  pln: Math.ceil(response.data.price_total_pln),
                  eur: Math.ceil(response.data.price_total_eur),
                  payment: 'total'
                }
              });
            } else {
              this.setState({
                current_state: 'unavailable',
                button_text: T('offer_unavailable'),
                loader: false
              });
            }
          })
          .catch(err => {
            console.log(`error: ${err}`);
          });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/upgrades/upgrade.js